import {
  type DocumentNode,
  type VariableDefinitionNode,
  visit,
} from 'graphql/language';
import {weakMemo} from '@packages/utilities/memo';

export const findDefinedQueryVariableNames = weakMemo(
  (query: DocumentNode): string[] => {
    const usedVariableNames: string[] = [];
    visit(query, {
      VariableDefinition(node: VariableDefinitionNode) {
        usedVariableNames.push(node.variable.name.value);
      },
    });
    return usedVariableNames;
  }
);
